// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalBanerFix-module--header--1QjfH","header2":"ModalBanerFix-module--header2--2iAlS"};